/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-undef-init */
/* eslint-disable react/no-this-in-sfc */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Calendar } from 'react-date-range';
import { toast } from 'react-toastify';
import moment from 'utils/moment';
import { isLocal, hostName } from '../../../../constants/apiEnv';
import styles from '../../../Badging/Scheduling/Scheduling.module.scss';
import Button from '../../../../components/button/button';
import Loading from '../../../../components/loading';
import { getCountryRegion } from '../../../../utils/helpers';

const Scheduling=(props) => {
  const { changePage, history, Uichange }= props;
  const url = hostName.slice(6);
  const savedOtp = useSelector(state => state.permitManagement.otp);
  const initialState = {
    selected_date: new Date(),
    selected_time_slot: '',
    useCalendarData: {},
    available_time_slots: [],
    person_details: {},
    dataError: false,
    useDisableDates: []
  };
  const [schedule_data, handleScheduleData] = useState(initialState);
  const [permitCategories, handlePermitCategories] = useState([]);
  const [blockedDate, setBlockedDate] = useState([]);
  const [adpCategory, setAdpCategory] = useState([]);
  const [apiSuccessMsg, handleApiStatus] = useState({ apiSuccessMessage: '', apiSuccess: false, loading: false });
  const [fieldErrors, handleFieldError] = useState({
    useFieldError: false
  });
  const { selected_time_slot, useCalendarData, airportData, available_time_slots,
    utcSlotStartDate, utcSlotEndDate, useDisableDates } = schedule_data;
  const duration_slot = useCalendarData?.settings?.schedule_duration === '1' ? 60 : Number(useCalendarData?.settings?.schedule_duration);
  const [startTimeInMinutes, setStartTimeInMinutes] = useState([]);
  const [endTimeInMinutes, setEndTimeInMinutes]= useState([]);
  const scheduleBasedCategory = useCalendarData?.settings?.advanced_settings?.filter(ele => ele.schedule_category === adpCategory);
  let slot_duration = undefined;
    if (scheduleBasedCategory && scheduleBasedCategory.length>0) {
    slot_duration = scheduleBasedCategory[0]?.schedule_duration;
  } else {
    slot_duration = duration_slot;
  }
  const createTimeSlots = (fromTime, toTime, slotDuration) => {
    let startTime = moment(fromTime, 'HH:mm');
    const endTime = moment(toTime, 'HH:mm');
    const slotList = [];
    const verifyTests = verifyNumberOfTests();
    if (verifyTests) {
      while (startTime.isSame(endTime) || startTime.isBefore(endTime)) {
        if (slotDuration === undefined || Number.isNaN(slotDuration)) {
          break;
        }
        const endTimeCheck = moment(toTime, 'HH:mm').subtract(slotDuration, 'minute');
        if (startTime.isSame(endTimeCheck) || startTime.isBefore(endTimeCheck)) {
          slotList.push(startTime.format('HH:mm'));
        }
        startTime = startTime.add(slotDuration, 'minute');
      }
    }
    return slotList;
  };

  const verifyNumberOfTests = (data) => {
    if (scheduleBasedCategory && scheduleBasedCategory.length>0 && data?.length>0 && adpCategory) {
      const scheduleBased = data.filter(ele => ele.adp_info?.category === adpCategory);
      if (Number(scheduleBased?.length) >= Number(scheduleBasedCategory[0]?.schedule_tests)) {
        return false;
      }
    }
    return true;
  };

  const { installationId, airportCode, id } = useParams();
  const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${getCountryRegion(installationId)}${url}/public`;

  function getDayIndex(weekday) {
    const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    return weekdays.indexOf(weekday);
  }

  const handleGetAvailbleDates = (weekday, selectedMonth) => {
    const today = new Date(selectedMonth);
    const currentMonth = today.getMonth();
    const dates = [];
    const targetDay = getDayIndex(weekday);
    // Set the date to the first day of the current month
    today.setDate(1);
    while (today.getMonth() === currentMonth) {
      if (today.getDay() === targetDay) {
        // If the current day is the target day, add it to the array
        dates.push(new Date(today));
      }
      today.setDate(today.getDate() + 1);
    }
    return dates;
  };

  const handleCalenderDates = (week_info, currentMonth) => {
    let unavaialbleDates = [];
    if (week_info) {
      Object.keys(week_info).forEach((eachWeek) => {
        if (week_info[eachWeek]?.length === 0) {
          unavaialbleDates = [...unavaialbleDates, ...handleGetAvailbleDates(eachWeek, currentMonth)];
        }
      });
    }
    return unavaialbleDates;
  };

  const handleGetBookingByDate = async (startDate, endDate, slotsList) => {
    try {
      const response = await fetch(`${publicUrl}/scheduling/list_bookings/${airportCode}/driver_permit?start=${startDate}&end=${endDate}`);
      const data = await response.json();

      let finalSlots = [...slotsList];
      const verifyTests = verifyNumberOfTests(data);
      if (verifyTests) {
      data.forEach((eachVal) => {
        const slotTime = moment(eachVal.start_ts).format('HH:mm');
        finalSlots = finalSlots.filter(slot => slotTime !== slot);
      });
      } else {
        finalSlots = [];
      }
      return finalSlots;
    } catch (error) {
      const message = 'There was a problem while retrieving the data';
      handleApiStatus({ apiSuccessMessage: message, error: true });
      throw error; // rethrow the error to indicate that an error occurred
    }
  };
  const convert12to24= (time12h) => {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
        hours = '00';
    }
    if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
};
  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const handledisableTime =(date, blockTimes) => {
    const convertedTimes = blockTimes.map((time) => {
     if (time.start_time && moment(time.block_date).format('l') === moment(date).format('l')) {
     return {
         start_time: time?.start_time.label.includes('AM')
          || time.start_time.label.includes('PM') ? convert12to24(time.start_time.label) : time.start_time.label,
         end_time: time?.end_time.label.includes('AM')
          || time.end_time.label.includes('PM') ? convert12to24(time.end_time.label) : time.end_time.label
     };
   }
     return {};
    });
    let removeempty =convertedTimes.filter(ele => Object.keys(ele).length !== 0) || [];
    if (removeempty && removeempty?.length > 0) {
     removeempty.forEach((item) => {
       const startTime = item.start_time;
       const endTime = item.end_time;
       setStartTimeInMinutes(prevStartTimes => [...prevStartTimes, timeToMinutes(startTime)]);
       setEndTimeInMinutes(prevEndTimes => [...prevEndTimes, timeToMinutes(endTime)]);
   });
}
   };

  const handleDateChange = async (useCalendarData2, airportData2, date, getLoading) => {
    if (getLoading) handleApiStatus({ ...apiSuccessMsg, loading: true });
    let s = new Date(date);
    let f = new Date(date);
    s.setHours(0, 0, 0, 0);
    f.setHours(24, 59, 59, 99);
    s = s.toISOString();
    f = f.toISOString();
    let weekDay= moment(date).format('ddd');
    weekDay = weekDay.toUpperCase();
    let week_availablity_info = useCalendarData2?.settings?.week_availablity_info;
    if (scheduleBasedCategory && scheduleBasedCategory?.length>0) {
      week_availablity_info = scheduleBasedCategory?.length>0 && scheduleBasedCategory[0]?.week_availablity_info;
    }
    const useAvailablityList = week_availablity_info?.[weekDay] || [];
    let getSlots = [];
    useAvailablityList.map((eachT) => {
      const takeSlot = createTimeSlots(eachT?.from?.value, eachT?.to?.value, slot_duration);
      getSlots = [...getSlots, ...takeSlot];
      return eachT;
    });
    const timeObjects = getSlots.map(time => new Date(`1970-01-01T${time}`));
    timeObjects.sort((a, b) => a - b);
    const sortedTimeSlots = timeObjects.map(time => time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }));
    const useTheseSlots = await handleGetBookingByDate(s, f, sortedTimeSlots);
    const disableDates = handleCalenderDates(week_availablity_info, date);
    let datecheck = useCalendarData?.settings?.blocked_details?.map(ele => ele.start_time && moment(ele.block_date).format('l'));
    if (datecheck?.includes(moment(date).format('l'))) {
      handledisableTime(date, useCalendarData?.settings?.blocked_details);
     } else {
      setStartTimeInMinutes('');
      setEndTimeInMinutes('');
     }
    handleScheduleData({ ...schedule_data,
      selected_date: date,
      available_time_slots: useTheseSlots,
      dataError: false,
      useCalendarData: useCalendarData2,
      airportData: airportData2,
      person_details: {},
      useDisableDates: disableDates,
      selected_time_slot: ''
    });
    handleApiStatus({ ...apiSuccessMsg, loading: false });
  };

  const addTimeToSelectedDate = (timeToAdd) => {
    // Clone the selected date to avoid modifying the original date object
    const newDate = new Date(schedule_data?.selected_date);

    // Extract hours and minutes from the timeToAdd string
    const [hours, minutes] = timeToAdd.split(':');

    // Add hours and minutes to the date
    newDate.setHours(newDate.getHours() + parseInt(hours, 10));
    newDate.setMinutes(newDate.getMinutes() + parseInt(minutes, 10));

    // Update the state with the new date
    const slot_durations = useCalendarData?.settings?.schedule_duration === '1' ? 60 : Number(useCalendarData?.settings?.schedule_duration);
    handleScheduleData({ ...schedule_data,
      selected_time_slot: timeToAdd,
      utcSlotStartDate: moment(newDate).format(),
      utcSlotEndDate: moment(newDate).add(slot_durations, 'minutes').format() });
  };

  const handleSelectSlot = (value) => {
    addTimeToSelectedDate(value);
  };

  const handleSkip = () => {
    try {
      fetch(`${publicUrl}/driver_permit/skip_booking/${id}/${airportCode}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          Authorization: savedOtp }
      })
        .then(() => {
          changePage('formStatus', 'completed');
          handleApiStatus({ apiSuccessMessage: 'Your schedule is saved. Admin will contact you.', apiSuccess: true });
        }).catch(() => {
          toast.error('Please try again later');
        });
    } catch (error) {
      handleApiStatus({ apiSuccessMessage: 'There was a problem while retrieving the data' });
    }
  };

  const handleSaveUpload = () => {
    const payload = {
      start_ts: utcSlotStartDate,
      end_ts: utcSlotEndDate
    };
    const noErrors = fieldErrors && Object.keys(fieldErrors)?.every(k => (fieldErrors[k] === false));
    if (noErrors && payload.start_ts) {
      try {
        fetch(`${publicUrl}/driver_permit/booK_slot_dp/${id}/${airportCode}`, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json',
            Authorization: savedOtp }
        })
          .then(() => {
            changePage('formStatus', 'completed');
            handleApiStatus({ apiSuccessMessage: 'Your schedule is saved. Admin will contact you.', apiSuccess: true });
          }).catch(() => {
            toast.error('Please try again later');
          });
      } catch (error) {
        handleApiStatus({ apiSuccessMessage: 'There was a problem while retrieving the data' });
      }
    } else if (payload.start_ts === undefined) {
      handleScheduleData({ ...schedule_data, dataError: true });
    } else {
      handleFieldError({
        ...fieldErrors,
        useFieldError: true
      });
    }
  };

  const handleNavigate = (dateRange) => {
    const disableDates = handleCalenderDates(useCalendarData?.settings?.week_availablity_info, dateRange);
    handleScheduleData({ ...schedule_data,
      useDisableDates: disableDates
    });
  };

  useEffect(() => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: savedOtp
    };
    Axios.get(
      `${
        publicUrl
      }/driver_permit/get_dp/${id}/${airportCode?.toUpperCase()}`,
      { headers }
    )
      .then(async (res) => {
        setAdpCategory(res.data?.permit?.category_of_adp || '');
      })
      .catch(() => {
        toast.error('Please try again later');
        setTimeout(() => {
          history.push(
            `/auth/adp/login/${props.match?.params?.countrycode
              || props.match?.params?.installationId}`
          );
        }, 2000);
      });
  }, []);

  useEffect(() => {
    try {
      handleApiStatus({ ...apiSuccessMsg, loading: true });
      fetch(`${publicUrl}/scheduling/booking/${airportCode}/driver_permit`)
        .then(response => response.json())
        .then((data) => {
          const todayDate = new Date();
          todayDate.setHours(0, 0, 0, 0);
          if (data?.calender) {
            handleDateChange(data?.calender, data.airport, todayDate, true);
          }
          if (data?.driver_permit) {
            handlePermitCategories(data?.driver_permit?.category_based_skill_test_setting);
          }
          if (data.calender) {
            const parsedBlockedDate = data?.calender?.settings?.blocked_details?.map(ele => !ele.start_time && ele.block_date) || [];
            setBlockedDate(parsedBlockedDate);
          }
        });
    } catch (error) {
      const message = 'There was a problem while retrieving the data';
      handleApiStatus({ apiSuccessMessage: message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const blockDate = blockedDate.map(ele => new Date(moment(ele)));
  const useDates =[...useDisableDates, ...blockDate];
  const selectedDate = moment(schedule_data?.selected_date).format('YYYY-MM-DD');
  const hasToday = useDates.some(dateString => moment(dateString).format('YYYY-MM-DD') === selectedDate);
  return (
    <>
      <Loading loadingStatus={apiSuccessMsg?.loading} />
      <div className={styles.Container} style={{ marginTop: Uichange ? '130px' : '0px' }}>
        <div className={styles.Container1}>
          <div className={styles.Container2}>
            <div className={styles.box}>
              <div className={styles.aeroStyle}>
                <div className={styles.box1}>
                  <img className={styles.imgstyle} src={airportData?.logo} alt="Aerosimple" />
                </div>
                <hr />
                <div className={styles.box3}>
                  <div style={{ color: '#7C869B', marginLeft: '25px', fontSize: '12px' }}>
                    <FormattedMessage id={airportData?.name || '-'} defaultMessage={airportData?.name} />
                  </div>
                  <div className={styles.aeroStyle2}>
                    <FormattedMessage id={useCalendarData?.title || '-'} defaultMessage={useCalendarData?.title} />
                  </div>
                  <div style={{ color: '#7C869B', margin: '10px 0 0 25px' }}>
                    <img className={styles.imgstyle1} src="https://cdn-icons-png.flaticon.com/128/1827/1827463.png" alt="Aerosimple" />
                    <span>
                    {slot_duration}
                      {' Min '}
                    </span>
                  </div>
                </div>
              </div>
                  <>
                    <div>
                      <div className={styles.title}>
                        <FormattedMessage id="scheduling.title" defaultMessage="Select date & time" />
                      </div>
                      <div className={styles.CalendarStyle}>
                        <Calendar
                          date={schedule_data?.selected_date}
                          dateFormat="yyyy-MM-DD"
                          onChange={e => handleDateChange(useCalendarData, airportData, e, true)}
                          color="#3A61A8"
                          disabledDay={(current) => {
                            const customDate = moment().format('MM-DD-YYYY');
                            return (
                              current
                              && (useDisableDates.includes(current) || current < moment(customDate, 'MM-DD-YYYY'))
                            );
                          }}
                          disabledDates={useDates}
                          style={{ fontSize: '0.9rem' }}
                          onShownDateChange={handleNavigate}
                        />
                      </div>
                    </div>
                    <div className={styles.thirdbox}>
                      <p className={styles.thirdbox1}>
                        {moment(schedule_data?.selected_date).format('dddd, MMMM D')}
                      </p>
                      <div className={styles.useTimeSty}>
                      {!hasToday && available_time_slots.map((time) => {
                          const timeInMinutes = timeToMinutes(time);
                          let disabled = false;
                          for (let i = 0; i < startTimeInMinutes.length; i++) {
                              const startTime = startTimeInMinutes[i];
                              const endTime = endTimeInMinutes[i];
                              if (timeInMinutes >= startTime && timeInMinutes <= endTime) {
                                  disabled = true;
                                  break; // Exit loop early if disabled is true
                              }
                          }
                          return (
                            <div className={`${styles.smallBox} ${selected_time_slot === time ? styles.activeSlat : ''}`}
                              onClick={() => !disabled && handleSelectSlot(time)}
                              role="presentation"
                              style={{ cursor: disabled ? 'not-allowed': 'pointer', borderColor: disabled ? 'gray' : '#3a61a8' }}
                            >
                              <span style={{ color: disabled && 'gray' }}>
                                {time}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </>
            </div>
            <hr className={styles.hrtag} />
            <div className={styles.btnstyle}>
              <div style={{ marginRight: '16rem' }}>
                {schedule_data?.dataError ? <span style={{ color: 'red', textAlign: 'center' }}>Please  select your time slot</span> : '' }
              </div>
              <div style={{ marginRight: '8px' }}>
                <Button
                  className={styles.saveBtn}
                  onClick={() => handleSkip()}
                  translationID="todo.newTask.save1"
                  defaultText="Skip" action="tertiary"
                />
              </div>
              <div>
                <Button
                  className={styles.saveBtn}
                  onClick={() => handleSaveUpload()}
                  translationID="todo.newTask.save1"
                  defaultText="Submit" action="secondary"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Scheduling;
